module.exports = __webpack_public_path__ + "static/about-us-04-7d0613f2c96429b6c70104b890b34bfc.png";